import Header from "../../../components/header/Header";
import AdminMainContainer from "../conatiner/admin.main.container/admin.main.container";

const AdminPage = () => {
  // const project = useAppSelector(selectedProject);

  return (
    <>
      <Header title="Admin" />
      <AdminMainContainer />
    </>
  )
}

export default AdminPage
